import React from 'react'
import { Popover } from 'antd'
import { link } from 'meinian-package/src/utils'
import { cdnImg } from 'meinian-package/src/utils/image'
import icon from 'meinian-package/src/component/icon'
import './index.less'

export default (props) => {
  const { url, style, itemId, placement, wrapStyle } = props
  return (<Popover
    placement={placement || 'rightTop'}
    overlayClassName="popover-item-img"
    content={<img
      src={cdnImg(url, 560)}
      style={{
        width: '280px',
        height: '280px',
        boxShadow: '0px 2px 8px 0px rgba(21, 33, 53, 0.15)',
        border: 'solid 4px #ffffff',
        objectFit: 'cover',
      }}
      alt=""
    />}
  >
    <div style={{ position: 'relative', display: 'inline-block', marginRight: 7, ...wrapStyle }}>
      <img
        loading="lazy"
        className="item-img-zy"
        style={{ ...style }}
        src={cdnImg(url, 280)}
      />
      {itemId && <img
        src={icon}
        style={{ zIndex: 1 }}
        className="item-img-icon"
        onClick={(e) => { link.toTaobaoGoodDetail(itemId); e.stopPropagation() }}
      />}
    </div>
  </Popover>)
}
